import { NavLink } from 'react-router';

/** Switch between the two separate alert systems (each has its own page, history and switches). */
export function SignalTabs() {
  return (
    <nav className="signal-tabs" aria-label="ระบบสัญญาณ">
      <NavLink to="/signals">สัญญาณ Stochastic</NavLink>
      <NavLink to="/sr">สัญญาณแนวรับแนวต้าน</NavLink>
    </nav>
  );
}
